module.exports = __webpack_public_path__ + "static/media/next.a8dc9442.svg";